module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Calisto MT"
    }
  }, [_vm._v("Tepatasi: Le Au’alumā")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "font-family": "Calisto Mt",
      "margin-left": "-10px",
      "margin-top": "20px",
      "font-weight": "normal !important"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_000#toc_id_1"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_001#toc_id_2"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_002#toc_id_3"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_004#id_Toc159854090"
    }
  }, [_vm._v("Book One")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_005#id_Toc159854091"
    }
  }, [_vm._v("I. 1905")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_006#id_Toc159854092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. 1910")])])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_007#id_Toc159854093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Two")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_008#id_Toc159854094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. July 1917")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_009#id_Toc159854095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Summer 1917")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_010#id_Toc159854096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. April 1918")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_011#id_Toc159854097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. September 1918")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_012#id_Toc159854098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. November 1918")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_013#id_Toc159854099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. 1919")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_014#id_Toc159854100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. Spring 1919")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_015#id_Toc159854101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. December 1919")])])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_016#id_Toc159854102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Three")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_017#id_Toc159854103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. 1921")])])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_018#id_Toc159854104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_019#id_Toc159854105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 60
// module chunks = 0